export class cAdminCustomers {
  constructor() {
    const input = document.getElementById('c-customer-filter') as HTMLInputElement | null;
    const tbody = document.querySelector('.c-admin-customers table tbody');
    
    if (!input || !tbody) return;

    const rows = tbody.querySelectorAll('tr');

    input.addEventListener('input', () => {
      const filter = input.value.toLowerCase();

      rows.forEach(row => {
        const idCell   = row.cells[1]?.textContent?.toLowerCase() ?? '';
        const nameCell = row.cells[2]?.textContent?.toLowerCase() ?? '';

        if (idCell.includes(filter) || nameCell.includes(filter)) {
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      });
    });
  }
}
